import script from "./ProjectAddClientDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectAddClientDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectAddClientDropdown.vue?vue&type=style&index=0&id=7bab4699&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bab4699"]])

export default __exports__